/**
 * Hình thức cấp phát
 */
export default {
  /// Dự toán
  Budget: 0,

  /// Lệnh chi
  TreasuryWarrant: 1,

  /// Hiện vật
  InKind: 2,

  /// Ghi thu - Ghi chi
  RecordReceiptExpense: 3,

  /// Khác
  Other: 4,
};
